import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Voice = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 20 20`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.75 4.375C10.75 3.96079 10.4142 3.625 10 3.625C9.58579 3.625 9.25 3.96079 9.25 4.375V15.625C9.25 16.0392 9.58579 16.375 10 16.375C10.4142 16.375 10.75 16.0392 10.75 15.625V4.375ZM7.37781 7.5C7.37781 7.08579 7.04202 6.75 6.62781 6.75C6.21359 6.75 5.87781 7.08579 5.87781 7.5V12.5C5.87781 12.9142 6.21359 13.25 6.62781 13.25C7.04202 13.25 7.37781 12.9142 7.37781 12.5V7.5ZM3.25562 8.625C3.66983 8.625 4.00562 8.96079 4.00562 9.375V10.625C4.00562 11.0392 3.66983 11.375 3.25562 11.375C2.8414 11.375 2.50562 11.0392 2.50562 10.625V9.375C2.50562 8.96079 2.8414 8.625 3.25562 8.625ZM16.7444 8.625C17.1586 8.625 17.4944 8.96079 17.4944 9.375V10.625C17.4944 11.0392 17.1586 11.375 16.7444 11.375C16.3302 11.375 15.9944 11.0392 15.9944 10.625V9.375C15.9944 8.96079 16.3302 8.625 16.7444 8.625ZM13.3722 6.75C13.7864 6.75 14.1222 7.08579 14.1222 7.5V12.5C14.1222 12.9142 13.7864 13.25 13.3722 13.25C12.958 13.25 12.6222 12.9142 12.6222 12.5V7.5C12.6222 7.08579 12.958 6.75 13.3722 6.75Z"
        fill={color}
      />
    </svg>
  )
})

export default Voice
